'use client';
import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';
import { system } from '@shared/theme';
import { AuthProvider } from '@shared/providers/AuthProvider';
import { Toaster } from '@/shared/components/ui/toaster';

export const AppProvider = ({ children }: PropsWithChildren) => (
  <ChakraProvider value={system}>
    <AuthProvider>{children}</AuthProvider>
    <Toaster />
  </ChakraProvider>
);
